import { render, staticRenderFns } from "./BasketItem.vue?vue&type=template&id=f5a862a4&scoped=true"
import script from "./BasketItem.vue?vue&type=script&lang=js"
export * from "./BasketItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a862a4",
  null
  
)

export default component.exports